// The operation panel's Parts on order rows (opOrders.js), pure: tests/unit/partRequests.test.mjs.
import { lineDue, poLines } from './poReceivingCore.js';
import * as C from './partRequestsCore.js';

/** The rows for one operation: [{ id, ref, vendor, items, state, text, tone, eta, fromTech }]. Pure. */
export function opOrderRows(opId, pos, reqs, today) {
  const rows = [];
  const seen = new Set();
  Object.entries(pos || {}).forEach(([id, po]) => {
    if (!po) return;
    const lines = poLines(po).map((l, i) => ({ l, i })).filter(({ l }) => l && l.Job_ID === opId);
    if (!lines.length) return;
    seen.add(id);
    const due = lines.reduce((t, { i }) => t + lineDue(po, i), 0);
    const items = lines.map(({ l }) => `${l.ordered} × ${l.partNumber || l.description || 'part'}`).join(', ');
    const etas = lines.filter(({ l, i }) => lineDue(po, i) > 0 && C.isDay(l.Expected_Date)).map(({ l }) => l.Expected_Date).sort();
    let state; let text; let tone;
    if (!due) { state = 'in'; text = 'Received'; tone = 'green'; }
    else if (po.open === false) { state = 'short'; text = 'Closed · never came'; tone = 'red'; }
    else if (etas[0]) {
      state = 'eta'; text = C.etaText(etas[0], today); tone = etas[0] < today ? 'red' : 'blue';
    } else { state = 'noeta'; text = 'On order · no delivery date yet'; tone = 'amber'; }
    rows.push({ id, ref: po.ref || '', vendor: po.vendor || '', items, state, text, tone, eta: etas[0] || '', fromTech: !!po.fromRequest, at: po.placedAt || 0 });
  });
  Object.entries(reqs || {}).forEach(([id, r]) => {
    if (!r || seen.has(id) || r.Op_Id !== opId) return;
    if (r.Status !== 'waiting' && r.Status !== 'declined') return;
    const items = C.keptLines(r.Lines).map(l => `${l.qty} × ${l.partNumber || l.description}`).join(', ');
    const waiting = r.Status === 'waiting';
    rows.push({ id, ref: r.Ref, vendor: r.Vendor_Name || '', items, state: r.Status, text: waiting ? `Waiting for office approval · from ${r.By_Name || 'a tech'}` : `Declined${r.Decline_Reason ? `: ${r.Decline_Reason}` : ''}`, tone: waiting ? 'amber' : 'grey', eta: '', fromTech: true, at: r.Sent_At || r.Created_At || 0 });
  });
  const rank = { waiting: 0, noeta: 1, eta: 1, short: 2, in: 3, declined: 4 };
  return rows.sort((a, b) => (rank[a.state] - rank[b.state]) || (a.eta || '9').localeCompare(b.eta || '9') || b.at - a.at);
}
